import React from "react";
import { HelpPanel } from "@amzn/awsui-components-react";
import { ExternalLinkGroup } from "../../commons";
import { learnMoreLinks } from "src/pages/commons/learn-more-links";

export function ToolsContent() {
  return (
    <HelpPanel
      header={<h2>Bulk Redrive Workflow Resource</h2>}
      footer={<ExternalLinkGroup items={learnMoreLinks} />}
    >
      <p>Perform bulk workflow redrives.</p>
      <ul>
        <li>
          Please input a csv file with external ids in the first column id and
          select a workflow type.
        </li>
        <li>
          In preview mode, you can edit any details you would like for each
          workflow prior to submission.
        </li>
        <li>
          Event version override is an optional field for FUSEN workflows.
        </li>
        <li>
          Create new workflow is an optional field for FUSEN workflows. This
          flag will create a new FUSEN workflow by default and will not resort
          to finding a previous work item (example usage: redriving workflows
          that only existing on ORCA DUB prior to ZAZ migration), we can use
          FBTSV2 using external id to open Fusen workflow. Note that if this is
          enabled, event version override does not work as expected to check the
          previous override value.
        </li>
        <li>Environment is required if create fusen workflow field is true.</li>
      </ul>
    </HelpPanel>
  );
}
